import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-02256d3a")

_pushScopeId("data-v-02256d3a")
const _hoisted_1 = { class: "slider" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.labelLeft)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "label left",
          textContent: _toDisplayString(_ctx.labelLeft)
        }, null, 8, ["textContent"]))
      : _createCommentVNode("", true),
    _createVNode("input", _mergeProps({
      max: _ctx.max,
      min: _ctx.min,
      style: { '--rangePercent': _ctx.percent },
      value: _ctx.value,
      class: "slider",
      type: "range"
    }, _ctx.$attrs, {
      onInput: _cache[1] || (_cache[1] = $event => (_ctx.value = $event.target.value))
    }), null, 16, ["max", "min", "value"]),
    (_ctx.labelRight)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: "label right",
          textContent: _toDisplayString(_ctx.labelRight)
        }, null, 8, ["textContent"]))
      : _createCommentVNode("", true)
  ]))
})